import './styles/App.css';
import twitterLogo from './assets/twitter-logo.svg';
import etherscanLogo from './assets/etherscan-logo.svg';
import React, { useEffect, useState } from "react";
import { ethers } from 'ethers';
import antCaveClub from './utils/AntCaveClub.json';

// Constants
const TWITTER_HANDLE = 'AntCaveClub';
const CONTRACT_ADDRESS = "0xdb7a41ed61da13515ead5f13b68eace25a1c3e37";
const TWITTER_LINK = `https://twitter.com/${TWITTER_HANDLE}`;
const ETHSCAN_LINK = `https://polygonscan.com/address/${CONTRACT_ADDRESS}`
const OPENSEA_LINK = 'https://opensea.io/collection/nft-pass-for-ant-cave-club';
const TOTAL_MINT_COUNT = 6666;

const App = () => {
  // 用户信息 
  const  [currentAccount, setCurrentAccount] = useState("");
  const  [totalCount, setTotalCount] = useState("");
  const  [nftCount, setNftCount] = useState("");
  const  [nftImages, setNftImages] = useState([]);

  // 检测钱包
  const checkIfWalletIsConnected = async () => {
    const { ethereum  } = window;

    if (!ethereum) {
      console.log("Make sure you have metamask!");
      return;
    } else {
      // console.log("We have the ethereum object", ethereum);
      // 添加网络
      await switchChain();

      await loadNFTInfo();
    }

    const accounts = await ethereum.request({ method: 'eth_accounts' });

    if (accounts.length !== 0) {
      const account = accounts[0];
      // console.log("Found an authorized account:", account);
      setCurrentAccount(account)

    } else {
      console.log("No authorized account found")
    }

  }

  // 切换网络 
  const switchChain = async () => {
    const { ethereum  } = window;

    if (!ethereum) {
      console.log("Make sure you have metamask!");
      return;
    } else {
      // console.log("We have the ethereum object", ethereum);
    }

    try {
    
      await ethereum.request({
        method: 'wallet_switchEthereumChain',
        params: [{ chainId: '0x89' }],
      });
    
    } catch (switchError) {
      // This error code indicates that the chain has not been added to MetaMask.
      if (switchError.code === 4902) {
        try {
          // await ethereum.request({
          //   method: 'wallet_addEthereumChain',
          //   params: [
          //     {
          //       chainId: '0x4',
          //       chainName: 'Rinkeby',
          //       rpcUrls: ['https://rinkeby.infura.io/v3/9aa3d95b3bc440fa88ea12eaa4456161'] /* ... */,
          //     },
          //   ],
          // });
          await ethereum.request({
            method: 'wallet_addEthereumChain',
            params: [
              {
                chainId: '0x89',
                chainName: 'Polygon Mainnet',
                nativeCurrency: {
                  name: 'MATIC',
                  symbol: 'MATIC',
                  decimals: 18
              }, //
              rpcUrls: ['https://polygon-rpc.com'] /* ... */,
              blockExplorerUrls: ['https://polygonscan.com']
              },
            ],
          });
        } catch (addError) {
          // handle "add" error
        }
      }
      // handle other "switch" errors
    }
  }

  // 链接钱包
  const connectWallet = async () => {
    try {
      const { ethereum } = window;

      if (!ethereum) {
        alert("Get Metamask!");
        return;
      }

      const accounts = await ethereum.request({ method: "eth_requestAccounts" });
      console.log("Connected", accounts[0]);
      setCurrentAccount(accounts[0]); 

    } catch (error) {
      console.log(error)
    }
  }
  
  // Mint NFT 
  const askContractToMintNft = async () => {

    try {
      const { ethereum } = window;
      
      if (ethereum) {
          const provider = new ethers.providers.Web3Provider(ethereum);
          const signer = provider.getSigner();
          const connectedContract = new ethers.Contract(CONTRACT_ADDRESS, antCaveClub.abi, signer);

          // NFT 价格
          const options = {
            value: ethers.utils.parseEther("50"),
            gasLimit: 500000
          }
          let nftTxn = await connectedContract.claim(options);

          await nftTxn.wait();
          console.log(`Mined, see transaction: https://polygonscan.com/tx/${nftTxn.hash}`);

      } else {
          console.log("Ethereum object doesn't exist!");
      }

    } catch (error) {

    }
  }

  // 加载NFT信息
  const loadNFTInfo = async () => {
    try {
      const { ethereum } = window;

      if (ethereum) {
        const provider = new ethers.providers.Web3Provider(ethereum);
        const signer = provider.getSigner();
        const connectedContract = new ethers.Contract(CONTRACT_ADDRESS, antCaveClub.abi, signer);
        
          // 加载 NFT 信息
          const total = await connectedContract.totalSupply();
          setTotalCount(total.toString());
    
          const nftCount = await connectedContract.balanceOf(currentAccount);     
          setNftCount(nftCount.toString());
          const ids = await connectedContract.walletOfOwner(currentAccount);
          let nftOrgImages = [];

          for(let i=0; i<ids.length; i++){
            const nftBase64 = await connectedContract.tokenURI(ids[i]);
            const decode = window.atob(nftBase64.split(",")[1]);
            const nftImage = JSON.parse(decode)["image"];
            nftOrgImages.push(nftImage);
          }
          setNftImages(nftOrgImages)
      }

    } catch (error) {
      
    }
  }
  // 钱包改变状态监听 
  const changeWalletListener = async () => {

    const { ethereum } = window;

    ethereum.on('accountsChanged', function (accounts) {
      console.log(`Accounts changed. All connected accounts are: ${accounts}`)
      if (accounts.length === 0) {
        console.log(`All accounts disconnected.`)
      } else {
        const account = accounts[0] // current active user
        setCurrentAccount(account);
        // console.log(`Currently the active user is ${accounts[0]}`)
      }
    })
  }


  // 监听事件
  const setupEventListener = async () => {
    try {
      const { ethereum } = window;

      
      if (ethereum) {
        const provider = new ethers.providers.Web3Provider(ethereum);
        const signer = provider.getSigner();
        const connectedContract = new ethers.Contract(CONTRACT_ADDRESS, antCaveClub.abi, signer);

        // 监听Mint 完成的事件 
        connectedContract.on("NewNFTPassMinted", (from, tokenId) => {
          console.log(from, tokenId.toNumber())
          alert(`恭喜🎉! 你已经获得了 NFT 并发送到了你的钱包. 你可以在 OpenSea 查看到: https://opensea.io/assets/${CONTRACT_ADDRESS}/${tokenId.toNumber()}`)
        
        })
      } else {
        
      }
    } catch (error) {
      console.log(error)
    }
  }

  // Render Methods
  const renderNotConnectedContainer = () => (
    <button onClick={connectWallet} className="cta-button connect-wallet-button">
      连接钱包
    </button>
  );

  useEffect(() => {
    checkIfWalletIsConnected();
  }, [currentAccount])

  useEffect(() => {
    setupEventListener();
  }, [currentAccount])

  useEffect(() => {
    changeWalletListener();
  }, [currentAccount])


  return (
    <div className="App">
      <div className="container">
        <div className="header-container">
          <p className="header gradient-text">Ant Cave Club's NFT</p>
          <p className="sub-text gradient-text-sub">
            社区成员专属 NFT, 你目前持有 {!nftCount ? "0": nftCount} 枚！ 
          </p>
          <p className="gradient-text-total">
              （ 🔥  {`${!totalCount ? "0": totalCount} / ${TOTAL_MINT_COUNT}`}  🏠 ）
          </p> 
          <p className="sub-text gradient-text-sub">
              {!currentAccount ? "": currentAccount.substring(0,6)+"..."+currentAccount.substring(36)}
          </p> 
          <p className="sub-text gradient-text-price">
              铸造 1 个 ACC NFT 需要 50 MATIC, 确保链接到（Polygon Mannet）
          </p> 
          
          {currentAccount === "" ? renderNotConnectedContainer() : (
            <>
            <button onClick={askContractToMintNft} className="cta-button connect-wallet-button">
              铸造 NFT
            </button>
            <button
            onClick={()=> nftCount==="0" ? alert("你需要持有NFT") : window.open("https://airtable.com/shrmnwfs5dtyaKiEO", "_blank")}
            className={nftCount!=="0" ? "cta-button connect-wallet-button" : "cta-button join-dao-button"} >
                成员群
            </button>
            </>
          )}
          <p className="sub-text">
            <a target="_blank" rel="noreferrer" href={OPENSEA_LINK}>
                <button className="cta-button connect-wallet-button">
                  查看 OpenSea 👀
                </button>
              </a>
          </p> 
        </div>
        
        {nftImages.length===0 ? "": 
        nftImages.map((element, index) => {
          return(
          <div key={index}>
            <img  alt="" className="nft-img" src={element} />
          </div>)
        })
      }
        

        <div className="footer-container">
          <img alt="Twitter Logo" className="twitter-logo" src={twitterLogo} />
          <a
            className="footer-text"
            href={TWITTER_LINK}
            target="_blank"
            rel="noreferrer"
          >{`@${TWITTER_HANDLE}`} 构建 </a>
        <img alt="Twitter Logo" className="twitter-logo" src={etherscanLogo} />
          <a
            className="footer-text"
            href={ETHSCAN_LINK}
            target="_blank"
            rel="noreferrer"
          >合约代码</a>
        </div>
      </div>
    </div>
  );
};

export default App;
